export default __webpack_public_path__ + "static/media/Pistol_9.60860a94.png";